import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Import components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import PaymentPackages from "./components/PaymentPackages";
import RequestForm from "./components/RequestForm";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import FeaturedTools from "./components/FeaturedTools";
import BestSellers from "./components/BestSellers";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancel from "./components/PaymentCancel";
import InvoicePayment from "./components/InvoicePayment";
import AdminPanel from "./components/AdminPanel";
import AdminLogin from "./components/AdminLogin";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import ToolStore from "./components/ToolStore";
import ToolDetail from "./components/ToolDetail";
import Cart from "./components/Cart";
import OrderSuccess from "./components/OrderSuccess";
import GuidesList from "./components/GuidesList";
import GuideDetail from "./components/GuideDetail";
import LinkHub from "./components/LinkHub";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";

const Home = () => {
  // When arriving with a hash (e.g. /#servicios from another page), scroll to it
  // once the content has rendered — native hash scroll is unreliable in SPAs.
  useEffect(() => {
    const hash = window.location.hash?.replace('#', '');
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 350);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <FeaturedTools />
      <BestSellers />
      <PaymentPackages />
      <RequestForm />
      <Testimonials />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tienda" element={<ToolStore />} />
              <Route path="/tienda/producto/:id" element={<ToolDetail />} />
              <Route path="/carrito" element={<Cart />} />
              <Route path="/orden/exito" element={<OrderSuccess />} />
              <Route path="/guias" element={<GuidesList />} />
              <Route path="/guias/:slug" element={<GuideDetail />} />
              <Route path="/links" element={<LinkHub />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-cancel" element={<PaymentCancel />} />
              <Route path="/invoice/:paymentCode" element={<InvoicePayment />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'hsl(var(--background))',
            color: 'hsl(var(--foreground))',
            border: '1px solid hsl(var(--border))',
          },
        }}
      />
    </div>
  );
}

export default App;
